<template>
  <MensagemErro v-if="erro" :titulo="titulo" :classe="nomeImposto" />
  <LoadingResultado v-else-if="ativarLoading" :titulo="titulo" :classe="nomeImposto" borderTop />
  <MensagemIpi v-else-if="regra == 0" :titulo="titulo" :classe="nomeImposto" />
  <MensagemIcmsInterno v-else-if="icmsAliquota == null" :titulo="titulo" :classe="nomeImposto" />
  <MultiplosSemResultado v-else-if="!exibeImposto" :titulo="titulo" :classe="nomeImposto" />
  <div v-else-if="imposto">
    <h2 class="nome-impressao">ICMS DIFERENCIAL DE ALÍQUOTAS</h2>
    <QuadroAlerta
      v-if="!!imposto.icms.length"
      :classe="nomeImposto"
      :dadosForm="dadosForm"
      @exibeAlerta="alerta => (exibeAlerta = alerta)"
    />
    <QuadroIcms
      v-if="regrasQuadroIcms"
      :borderTop="!imposto.icms.length || !exibeAlerta"
      :id="id"
      :imposto="imposto"
      :edita="editaIcms"
      :seleciona="selecionaIcms"
      :selecionado="icmsSelecionado"
      :selecionouIcms="selecionouIcms"
      :loading="loading"
      :reduzAliquota="reduzAliquota"
      :classe="nomeImposto"
    />
    <FundoIcms
      v-if="selecionouIcms"
      :classe="nomeImposto"
      :fundo="imposto.fundo"
      :seleciona="selecionaFundo"
      :fundoSelecionado="fundoSelecionado"
      :selecionouFundo="selecionouFundo"
      :edita="editaFundo"
      :loading="loading"
      :aliquotaEfetivaSelecionada="aliquotaEfetivaSelecionada"
    />
    <BeneficiosIcms
      v-if="
        (!!imposto.beneficios.length || alteracaoImportacao) &&
          selecionouIcms &&
          !ativarLoadingSecundario &&
          icmsSelecionado.label != 'Não Incidência'
      "
      :key="forceRerenderKeyBeneficios"
      :beneficios="imposto.beneficios"
      :beneficioSelecionado="beneficioSelecionado"
      :classe="nomeImposto"
      :seleciona="selecionaBeneficio"
      :selecionouBeneficio="selecionouBeneficio"
      :loading="loading"
    />
    <ResultadoDifal
      v-if="resultadoDifal && !ativarLoadingSecundario && !ativarLoadingTerciario"
      :dados="resultadoDifal"
    />
    <LoadingResultado v-if="loading" :titulo="''" :classe="nomeImposto" />
  </div>
</template>

<script>
import rotaBufferMixin from "@/mixins/rotaBufferMixin";

import BeneficiosIcms from "@/components/BeneficiosIcms/BeneficiosIcms.vue";
import FundoIcms from "@/components/FundoIcms/FundoIcms.vue";
import ImpostoSemResultado from "@/components/ImpostoSemResultado/ImpostoSemResultado.vue";
import MultiplosSemResultado from "@/components/ImpostoSemResultado/MultiplosSemResultado.vue";
import LoadingResultado from "@/components/LoadingResultado/LoadingResultado.vue";
import MensagemIcmsInterno from "@/components/MensagemIcmsInterno/MensagemIcmsInterno.vue";
import MensagemIpi from "@/components/MensagemIpi/MensagemIpi.vue";
import MensagemErro from "@/components/MensagemErro/MensagemErro.vue";
import QuadroAlerta from "@/components/QuadroAlerta/QuadroAlerta.vue";
import QuadroIcms from "@/components/QuadroIcms/QuadroIcms.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import ResultadoDifal from "@/components/ResultadoDifal/ResultadoDifal.vue";

import { mapActions, mapGetters } from "vuex";
export default {
  name: "IcmsDifal",

  mixins: [rotaBufferMixin],

  props: {
    id: String | Number,
    buscarImposto: Function,
    tributoAtivo: String,
    limparImpostos: Boolean,
    exibeImposto: Boolean
  },

  inject: ["alteracaoImportacao"],

  components: {
    BeneficiosIcms,
    FundoIcms,
    ImpostoSemResultado,
    MultiplosSemResultado,
    LoadingResultado,
    MensagemIcmsInterno,
    MensagemIpi,
    MensagemErro,
    QuadroAlerta,
    QuadroIcms,
    QuadroPrincipal,
    ResultadoDifal
  },

  data() {
    return {
      exibeAlerta: false,
      titulo: "ICMS DIFAL",
      ativarLoading: false,
      ativarLoadingSecundario: false,
      ativarLoadingTerciario: false,
      beneficiosKey: 0,
      nomeImposto: "difal",
      imposto: null,
      icmsSelecionado: {},
      fundoSelecionado: {},
      beneficioSelecionado: {},
      resultadoDifal: null,
      selecionouIcms: false,
      selecionouFundo: false,
      selecionouBeneficio: false,
      requerFundo: true,
      dadosForm: {},
      regra: 0,
      icmsAliquota: null,
      icmsAliquotaBackup: null,
      forceRerenderKeyBeneficios: 0,
      reduzAliquota: 0,
      erro: false,
      teste: { nome: "Difal" },
      isencaoDifal: {
        dados: [
          {
            label: "Inaplicabilidade da Diferencial de Alíquotas",
            texto_inaplicabilidade:
              "Não se aplica a Diferencial de Alíquotas, caso a operação esteja sujeita a Não Incidência do ICMS.",
            id_imposto: 100
          }
        ]
      }
    };
  },

  created() {
    this.setSelecao({ selecao: { selecionouIcmsDifal: this.selecionouIcmsDifal }, id: this.id });
  },

  updated() {
    if (this.selecionouIcmsDifal) {
      this.setLog(this.impressaoLog);
    }
  },

  watch: {
    async tributoAtivo(newValue) {
      this.erro = false;
      // PUXA VALOR DE REGRA DO IPI QUANDO TROCA DE ABA
      this.regra = this.getDadosForm[this.id].regra;
      // PUXA VALOR DE ALÍQUOTA DO ICMS QUANDO TROCA DE ABA
      this.icmsAliquota = this.getDadosForm[this.id].aliquotaIcmsSelecionada;

      // VERIFICA SE HOUVE TROCA DE ALÍQUOTA DO ICMS INTERNO
      if (this.icmsAliquota != this.icmsAliquotaBackup) {
        this.imposto = null;
      }

      if (
        newValue == this.nomeImposto &&
        this.regra != 0 &&
        !this.imposto &&
        !this.ativarLoading &&
        this.icmsAliquota != null &&
        this.exibeImposto
      ) {
        this.editaIcms();
        // ATUALIZA O BACKUP DA ALIQUOTA PARA FUTURAS VERIFICAÇÕES
        this.icmsAliquotaBackup = this.icmsAliquota;

        this.dadosForm = { ...this.getDadosForm[this.id] };
        this.ativarLoading = true;
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            [this.imposto] = await this.buscarImposto({
              imposto: this.nomeImposto,
              idCenario: this.id
            });
            this.imposto = { ...this.imposto, classe: "difal" };
            tentativas = 3;
          } catch (error) {
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              console.error(error);
              this.erro = true;
              this.ativarLoading = false;
            }
          }
        }
        this.ativarLoading = false;
      }
    },

    limparImpostos(newValue) {
      if (newValue) {
        this.imposto = null;
        this.editaIcms();
      }
    },

    loading() {
      this.$emit("loading", this.loading);
    },

    selecionouIcmsDifal() {
      this.setSelecao({ selecao: { selecionouIcmsDifal: this.selecionouIcmsDifal }, id: this.id });
    }
  },

  computed: {
    ...mapGetters("form", ["getDadosForm"]),
    ...mapGetters("reRender", ["getRenderKey"]),

    loading() {
      if (this.ativarLoading || this.ativarLoadingSecundario || this.ativarLoadingTerciario) {
        return true;
      }
      return false;
    },

    regrasQuadroIcms: function() {
      return !!this.imposto.icms;
    },

    aliquotaEfetivaSelecionada() {
      if (this.selecionouIcms && this.selecionouFundo) {
        // CÁLCULO DE ALÍQUOTA EFETIVA BASEADO NA REGRA DO FUNDO
        if (this.fundoSelecionado.regra_fundo == 2) {
          this.reduzAliquota = this.fundoSelecionado.aliquota;
          return Number(this.icmsSelecionado.aliquota);
        } else {
          this.reduzAliquota = 0;
          return Number(this.icmsSelecionado.aliquota) + Number(this.fundoSelecionado.aliquota);
        }
        // FIM
      }
      this.reduzAliquota = 0;
      return null;
    },
    selecionouIcmsDifal() {
      const selecionou = [
        this.selecionouIcms,
        !this.requerFundo || this.selecionouFundo
        // !this.requerMva || this.selecionouMva
      ];
      // DEBUG CONSOLE
      // console.log(selecionou);
      return !selecionou.filter(boolean => boolean == false).length;
    },

    impressaoLog() {
      let log = {
        logIcmsDifal: {
          icms: this.icmsSelecionado,
          fundo: this.fundoSelecionado,
          beneficio: this.beneficioSelecionado,
          difal: this.resultadoDifal
        }
      };
      return log;
    }
  },

  methods: {
    ...mapActions("tributosSelecionados", ["setSelecao"]),
    ...mapActions("logResultados", ["setLog"]),

    padronizaRequerimentosImpressao(boolean) {
      this.requerFundo = boolean;
    },

    async selecionaIcms(imposto) {
      this.resultadoDifal = null;
      this.icmsSelecionado = imposto;
      this.selecionouIcms = true;

      // PAYLOAD
      this.dadosForm.v_aliquota = this.icmsSelecionado.aliquota;
      this.dadosForm.id_beneficio = null;
      this.dadosForm.id_beneficio_uf = null;
      this.dadosForm.id_convenio_mapa_difal = null;
      this.dadosForm.id_convenio_mapa_icms = null;
      // FIM

      // BUSCA RESULTADO PARA IMPOSTO DO DIFAL
      if (imposto.label != "Não Incidência") {
        this.ativarLoadingSecundario = true;
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            this.resultadoDifal = await this.chamadaRota(
              "Cenario/obterImpostoDifal",
              this.dadosForm
            );
            tentativas = 3;
          } catch (error) {
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              console.error(error);
              this.erro = true;
              this.ativarLoadingSecundario = false;
            }
          }
        }
        this.ativarLoadingSecundario = false;
        this.requerFundo = this.imposto ? !!this.imposto.fundo.dados.length : true;
      } else {
        this.resultadoDifal = this.isencaoDifal;
        this.padronizaRequerimentosImpressao(false);
      }
      // FIM
    },

    selecionaBeneficio(id) {
      this.resultadoDifal = null;
      this.beneficios = this.imposto.beneficios.map(beneficio => {
        if (beneficio.id_imposto == id) {
          this.beneficioSelecionado = beneficio.selecionado ? beneficio : {};
          this.selecionouBeneficio = beneficio.selecionado;
          this.beneficioClasse = beneficio.label;

          this.dadosForm.id_beneficio = this.selecionouBeneficio
            ? beneficio.id_tributacao_geral
            : null;
          this.dadosForm.id_beneficio_uf = this.selecionouBeneficio
            ? beneficio.id_tributacao_uf
            : null;
          this.dadosForm.id_convenio_mapa_difal = this.selecionouBeneficio
            ? beneficio.id_convenio_mapa
            : null;
          this.dadosForm.id_convenio_mapa_icms = this.selecionouBeneficio
            ? beneficio.id_convenio_geral
            : null;
        } else {
          beneficio.selecionado = false;
        }
        return beneficio;
      });
      this.forceRerenderKeyBeneficios += 1;

      // CHAMA OU NÃO O DIFAL QUANDO SELECIONADO BENEFÍCIO
      this.chamadaBeneficio();
    },

    selecionaFundo(imposto) {
      this.fundoSelecionado = imposto;
      this.selecionouFundo = true;
    },

    async chamadaBeneficio() {
      this.ativarLoadingTerciario = true;
      if (this.selecionouBeneficio) {
        // CHAMA RESULTADO DO DIFAL CASO NÃO SEJA BENEFÍCIO DE ISENÇÃO
        if (this.beneficioClasse != "Isenção") {
          let tentativas = 0;
          while (tentativas < 3) {
            try {
              this.resultadoDifal = await this.chamadaRota(
                "Cenario/obterImpostoDifal",
                this.dadosForm
              );
              tentativas = 3;
            } catch (error) {
              tentativas++;
              console.error(`${tentativas}ª tentativa`);
              if (tentativas === 3) {
                console.error(error);
                this.erro = true;
                this.ativarLoadingTerciario = false;
              }
            }
          }
        } else {
          // SE FOR BENEFÍCIO DE ISENÇÃO MOSTRA ALERTA DO FRONT
          this.resultadoDifal = this.isencaoDifal;
        }
      } else {
        // REINICIA PAYLOAD
        this.dadosForm.id_beneficio = null;
        this.dadosForm.id_beneficio_uf = null;
        this.dadosForm.id_convenio_mapa_difal = null;
        this.dadosForm.id_convenio_mapa_icms = null;
        // FIM
        // EXIBE RESULTADO SEM BENEFÍCIO
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            this.resultadoDifal = await this.chamadaRota(
              "Cenario/obterImpostoDifal",
              this.dadosForm
            );
            tentativas = 3;
          } catch (error) {
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              console.error(error);
              this.erro = true;
              this.ativarLoadingTerciario = false;
            }
          }
        }
      }
      this.ativarLoadingTerciario = false;
    },

    editaIcms() {
      this.icmsSelecionado = {};
      this.selecionouIcms = false;
      this.beneficios = null;
      this.resultadoDifal = null;
      this.reduzAliquota = 0;
      // this.selecionouMva = false;
      this.padronizaRequerimentosImpressao(true);
      this.editaFundo();
      this.editaBeneficios();
    },

    editaFundo() {
      this.fundoSelecionado = null;
      this.selecionouFundo = false;
    },

    editaBeneficios() {
      this.beneficioSelecionado = {};
      this.selecionouBeneficio = false;
      this.resultadoDifal = null;
      if (this.imposto && this.imposto.beneficios) {
        this.imposto.beneficios.map(beneficio => {
          beneficio.selecionado = false;
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
